import { NextApiResponse } from 'next'

type ResponseType = {
  res: NextApiResponse
  status: number
}

export const redirectTo = (
  url: string,
  { res, status }: ResponseType,
): void => {
  res.writeHead(status || 302, { Location: url })
  res.end()
}
